export default "__VITE_ASSET__b7a28d6c__"